import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box } from '@chakra-ui/react';
import { AutocompleteLocation, Icon, InfoMessage, LogoHubSimple, LogoZipSimple, PremierInnLogo } from '@whitbread-eos/atoms';
import { analytics } from '@whitbread-eos/utils';
import { useEffect, useState } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MAX_ITEMS_PER_SECTION = 5;
export default function LocationPicker(_ref) {
  var isLocationRequired = _ref.isLocationRequired,
    hasListDivider = _ref.hasListDivider,
    showErrorMessage = _ref.showErrorMessage,
    inputPlaceholder = _ref.inputPlaceholder,
    defaultInputValue = _ref.defaultInputValue,
    suggestions = _ref.suggestions,
    errorMessage = _ref.errorMessage,
    styles = _ref.styles,
    onSelectLocation = _ref.onSelectLocation,
    onInputChange = _ref.onInputChange,
    onInputClear = _ref.onInputClear,
    onInputFocus = _ref.onInputFocus,
    _ref$showElements = _ref.showElements,
    showElements = _ref$showElements === void 0 ? true : _ref$showElements,
    isPriceFinder = _ref.isPriceFinder;
  var _useState = useState(defaultInputValue !== null && defaultInputValue !== void 0 ? defaultInputValue : ''),
    _useState2 = _slicedToArray(_useState, 2),
    inputSelectedValue = _useState2[0],
    setInputSelectedValue = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchTerm = _useState4[0],
    setSearchTerm = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    selectionInitialized = _useState6[0],
    setSelectionInitialized = _useState6[1];
  var hasClearIcon = !!(inputSelectedValue !== null && inputSelectedValue !== void 0 ? inputSelectedValue : searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.length);
  useEffect(() => {
    if (searchTerm !== null && searchTerm !== void 0 && searchTerm.length) {
      onInputChange === null || onInputChange === void 0 || onInputChange(searchTerm);
    }
  }, [searchTerm]);
  useEffect(() => {
    setInputSelectedValue(defaultInputValue);
  }, [defaultInputValue]);
  useEffect(() => {
    if ((suggestions.managedPlaces.length > 0 || suggestions.places.length > 0 || suggestions.properties.length > 0) && !selectionInitialized) {
      var _ref2;
      handleLocationChange((_ref2 = defaultInputValue !== null && defaultInputValue !== void 0 ? defaultInputValue : searchTerm) !== null && _ref2 !== void 0 ? _ref2 : '');
      setSelectionInitialized(true);
    }
  }, [suggestions, selectionInitialized, defaultInputValue]);
  return _jsxs(Box, _objectSpread(_objectSpread({
    position: 'relative',
    zIndex: 2
  }, styles.locationPickerStyles), {}, {
    marginBottom: styles.errorMarginBottom,
    children: [_jsx(AutocompleteLocation, {
      items: mapItemsForAutocomplete(suggestions),
      inputPlaceholder: inputPlaceholder,
      inputSelectedValue: inputSelectedValue,
      onChange: handleLocationChange,
      onInputChange: handleInputChange,
      onClearInput: handleClearInput,
      onBlurInput: handleBlurInput,
      onFocusInput: handleFocusInput,
      hasClearIcon: hasClearIcon,
      hasListDivider: hasListDivider,
      isRequired: isLocationRequired,
      openListOnFocus: false,
      disableInternalFilter: true,
      autocompleteStyles: _objectSpread({}, styles),
      dataTestId: "locationPicker",
      showElements: showElements,
      isPriceFinder: isPriceFinder,
      ariaInvalid: showErrorMessage,
      ariaDescribedBy: showErrorMessage ? 'location-picker-error' : undefined
    }), showErrorMessage && errorMessage && _jsx(InfoMessage, {
      infoMessage: errorMessage,
      otherStyles: isPriceFinder ? alertStylesPriceFinder : alertStyles,
      messageId: "location-picker-error"
    })]
  }));
  function handleInputChange(value) {
    setSearchTerm(value);
    setInputSelectedValue(value);
  }
  function handleLocationChange(location) {
    setInputSelectedValue(location);
    var selectedLocation = getSelectedItem(location);
    onSelectLocation === null || onSelectLocation === void 0 || onSelectLocation(selectedLocation);
    if ('placeId' in selectedLocation && selectedLocation.placeId) {
      analytics.update({
        selectedSearch: {
          suggestion: selectedLocation.suggestion,
          placeId: selectedLocation.placeId
        }
      });
      if (typeof window !== 'undefined') {
        var _window;
        (_window = window) === null || _window === void 0 || _window.dispatchEvent(new CustomEvent('userSelectedSearchLocation'));
      }
    }
    if ('brand' in selectedLocation && selectedLocation.brand) {
      analytics.update({
        selectedSearch: {
          brand: selectedLocation.brand,
          code: selectedLocation.code,
          suggestion: selectedLocation.suggestion,
          geometry: selectedLocation.geometry
        }
      });
      if (typeof window !== 'undefined') {
        var _window2;
        (_window2 = window) === null || _window2 === void 0 || _window2.dispatchEvent(new CustomEvent('userSelectedSearchLocation'));
      }
    }
  }
  function getSelectedItem(item) {
    var items = [...suggestions.managedPlaces, ...suggestions.places, ...suggestions.properties];
    var suggestion = items.find(element => {
      var _element$suggestion;
      return (element === null || element === void 0 || (_element$suggestion = element.suggestion) === null || _element$suggestion === void 0 ? void 0 : _element$suggestion.replace(/\//g, ' ')) === (item === null || item === void 0 ? void 0 : item.replace(/\//g, ' '));
    });
    return suggestion !== null && suggestion !== void 0 ? suggestion : items[0];
  }
  function handleClearInput() {
    setSearchTerm('');
    setInputSelectedValue('');
    onInputClear === null || onInputClear === void 0 || onInputClear();
  }
  function handleBlurInput(value) {
    handleLocationChange(value);
  }
  function handleFocusInput() {
    onInputFocus === null || onInputFocus === void 0 || onInputFocus(searchTerm);
  }
  function getLogoByBrand(brand, code) {
    var logoStyle = {
      position: 'relative',
      transform: 'scale(0.45)'
    };
    var iconStyle = {
      width: 'var(--chakra-space-lg)',
      height: 'var(--chakra-space-lg)',
      marginRight: 'var(--chakra-space-md)'
    };
    if (brand === 'PI' || brand === 'PID') {
      return _jsx(Box, {
        mr: "md",
        style: {
          position: 'relative',
          top: '-0.125rem'
        },
        children: _jsx(PremierInnLogo, {})
      }, code);
    }
    if (brand === 'HUB') {
      return _jsx(Icon, {
        style: iconStyle,
        svg: _jsx(LogoHubSimple, {
          style: _objectSpread(_objectSpread({}, logoStyle), {}, {
            top: '-1.25rem',
            left: '-1.125rem'
          })
        })
      }, code);
    }
    if (brand === 'ZIP') {
      return _jsx(Icon, {
        style: iconStyle,
        svg: _jsx(LogoZipSimple, {
          style: _objectSpread(_objectSpread({}, logoStyle), {}, {
            top: '-0.375rem',
            left: '-1.5rem'
          })
        })
      }, code);
    }
  }
  function mapItemsForAutocomplete(items) {
    var _items$managedPlaces, _items$places, _items$properties;
    var mappedManagedPlaces = items === null || items === void 0 || (_items$managedPlaces = items.managedPlaces) === null || _items$managedPlaces === void 0 ? void 0 : _items$managedPlaces.map(managedPlace => {
      return {
        value: managedPlace.suggestion
      };
    });
    var mappedPlaces = items === null || items === void 0 || (_items$places = items.places) === null || _items$places === void 0 ? void 0 : _items$places.map(place => {
      return {
        value: place.suggestion
      };
    });
    var mappedProperties = items === null || items === void 0 || (_items$properties = items.properties) === null || _items$properties === void 0 ? void 0 : _items$properties.map(property => {
      return {
        value: property.suggestion,
        group: 'Hotels',
        component: getLogoByBrand(property.brand, property.code)
      };
    });
    var places = [...mappedManagedPlaces, ...mappedPlaces].slice(0, MAX_ITEMS_PER_SECTION);
    var hotels = [...mappedProperties].slice(0, MAX_ITEMS_PER_SECTION);
    return [...places, ...hotels];
  }
}
var alertStyles = {
  w: {
    base: 'full',
    sm: '25.313rem',
    lg: 'full'
  },
  h: '40px',
  zIndex: 1,
  mb: 0
};
var alertStylesPriceFinder = {
  position: 'absolute',
  w: {
    base: 'full',
    md: 'auto'
  },
  h: '40px',
  zIndex: 1
};